import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";

interface TaxPayerApiKeyRawKeyModalProps {
  show: boolean;
  rawKey: string;
  keyName: string;
  onClose: () => void;
}

const TaxPayerApiKeyRawKeyModal: React.FC<TaxPayerApiKeyRawKeyModalProps> = ({
  show,
  rawKey,
  keyName,
  onClose,
}) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(rawKey);
  };

  return (
    <CModal show={show} onClose={onClose} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>API Key creada: {keyName}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <div className="alert alert-warning">
                <strong>Atención:</strong> Esta es la única vez que se mostrará
                la API Key completa. Cópiela y guárdela en un lugar seguro.
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <div
                className="p-3 bg-dark text-white rounded d-flex align-items-center justify-content-between"
                style={{ wordBreak: "break-all", fontFamily: "monospace" }}
              >
                <span>{rawKey}</span>
                <CButton
                  color="light"
                  size="sm"
                  className="ml-3 flex-shrink-0"
                  onClick={copyToClipboard}
                >
                  <i className="fa fa-copy"></i> Copiar
                </CButton>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={onClose}>
          Entendido, ya la copié
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default TaxPayerApiKeyRawKeyModal;
